module.exports = __webpack_public_path__ + "img/5.85809577.jpg";